module.exports = __webpack_public_path__ + "img/values-innovation.0d0c53ff.gif";